// Utilitaires pour gérer les chemins d'images dans Electron et navigateur
import { isElectron } from './electron';

/**
 * Corrige le chemin d'une image pour qu'il fonctionne dans Electron et navigateur
 * @param {string} path - Chemin de l'image (ex: '/assets/logo/1.webp')
 * @returns {string} - Chemin corrigé
 */
export const getImagePath = (path) => {
  // Si le chemin commence par /, le convertir en chemin relatif pour Electron
  if (isElectron() && path.startsWith('/')) {
    // Dans Electron, utiliser ./ au lieu de /
    return '.' + path;
  }
  // Dans le navigateur, garder le chemin tel quel
  return path;
};

/**
 * Obtient l'URL complète d'une image avec fallback Pexels si nécessaire
 * @param {string} localPath - Chemin local de l'image
 * @param {string} pexelsUrl - URL Pexels en fallback
 * @returns {string} - URL de l'image à utiliser
 */
export const getImageUrlWithFallback = (localPath, pexelsUrl = null) => {
  const correctedPath = getImagePath(localPath);
  
  // Si on est dans Electron, essayer d'abord le chemin local
  if (isElectron()) {
    return correctedPath;
  }
  
  // Dans le navigateur, utiliser le chemin local
  return correctedPath;
};

export default {
  getImagePath,
  getImageUrlWithFallback
};
